import { is58App } from 'api/Helper';

export const mobileLogin = {
    getCode: () => {},
    freshValidateCode: () => {},
    loginCommit: () => {},
};
const loadPassportjs = (call) => {
    const WBAPP = window.WBAPP ? window.WBAPP : {};
    console.log(WBAPP);
    if (is58App() && WBAPP.util.compareVersion(WBAPP.common.appVersion, '8.3') >= 0) {
        call();
        mobileLogin.getCode = ({ mobile, callback }) => {
            WBAPP.invoke('get_verification_code', {
                tel: mobile,
            }, (data) => {
                const res = JSON.parse(data);
                if (res.state === '0') {
                    // 防止用户刷新或者关闭页面，这里存储起来，登录后清除
                    localStorage.setItem('get_verification_code_token', res.token);
                    callback({
                        code: 0,
                    });
                } else {
                    callback({
                        code: 1,
                        msg: '获取码验证失败!',
                    });
                }
            });
        };
        mobileLogin.loginCommit = ({ mobile, mobilecode, callback }) => {
            console.log('触发');
            WBAPP.invoke('login_use_code', {
                tel: mobile, // 电话号码
                verification: mobilecode, // 验证码
                token: localStorage.getItem('get_verification_code_token'), // get_verification_code 传过来的token值
            }, (data) => {
                if (data === '0') {
                    localStorage.removeItem('get_verification_code_token');
                    callback({
                        code: 0,
                    });
                } else {
                    callback({
                        code: 1,
                        msg: '登录失败!',
                    });
                }
            });
        };
    } else {
        const passportjs = document.createElement('script');
        passportjs.type = 'text/javascript';
        passportjs.src = `${(document.location.protocol === 'https:') ? ' https://' : ' http://'}j1.58cdn.com.cn/js/login/passportMobileLogin.js`;
        passportjs.onload = () => {
            call();
            const _mobileLogin = new window.MobileLogin({
                source: '58-haojie-m',
                path: window.location.href,
            });
            mobileLogin.getCode = _mobileLogin.getCode.bind(_mobileLogin);
            mobileLogin.freshValidateCode = _mobileLogin.freshValidateCode.bind(_mobileLogin);
            mobileLogin.loginCommit = _mobileLogin.loginCommit.bind(_mobileLogin);
        };
        const s = document.getElementsByTagName('script')[0];
        s.parentNode.insertBefore(passportjs, s);
    }
};
export default loadPassportjs;



// WEBPACK FOOTER //
// ./src/pages/ground/components/LoadPassportJs/index.js